import { render } from "./ChangeWeight.vue?vue&type=template&id=15c31239"
import script from "./ChangeWeight.vue?vue&type=script&lang=js"
export * from "./ChangeWeight.vue?vue&type=script&lang=js"

import "./ChangeWeight.vue?vue&type=style&index=0&id=15c31239&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__